<div class="mydocma-dialog-container">

  <div class="mydocma-dialog-header" *ngIf="!this.mediaQueryService?.isXs; else mobileHeader">
    <div class="mydomca-dialog-header-title">
      {{title$ | async}}
    </div>
    <div>
      <button mat-icon-button type= "button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>

    </div>
  </div>

  <div class="mydocma-dialog-body">
    <mydocma-loader [size]="'small'" class="mydocma-mm-loader" *ngIf="(loading$ | async) || (saving$ | async)"></mydocma-loader>
    <div class="ld-dialog-content" mydocmaResizeEvent (resize)="onResize($event)">

      <div class="ld-grid-layout">
        <div style="grid-column: 1; grid-row: 1 / 3">
          <mat-radio-group class="duplicate-radio-group" [(ngModel)]="duplicateMode" (change)="onDuplicateModeChanged()">
            <mat-radio-button [value]="layoutDuplicateModes.OnlyDuplicate" [disabled]="isScopeForced$ | async" style="margin: 5px 0 5px 0"></mat-radio-button>
            <mat-radio-button [value]="layoutDuplicateModes.DuplicateAndChangeType" style="margin: 5px 0 5px 0"></mat-radio-button>
          </mat-radio-group>
        </div>
        <div style="grid-column: 2; grid-row: 1; align-self: center">{{'MM.layout.labelDuplicate' | translate}}</div>
        <div style="grid-column: 2; grid-row: 2; align-self: center">{{'MM.layout.labelDuplicateAndChangeType' | translate}}</div>
        <div style="grid-column: 1; grid-row: 3"></div>
        <div style="grid-column: 2; grid-row: 3; padding-right: 28px">
          <div class="mydocma-form">
            <mydocma-form-field maxCollapsedWidth="10" [showClearButton] = "false">
              <mat-label>
                {{'MM.layout.labelDuplicateType' | translate}}
              </mat-label>
              <mat-select [disabled]="duplicateMode === layoutDuplicateModes.OnlyDuplicate"  [(ngModel)]="selectedScope" (selectionChange)="selectedScopeChanged($event)"  >
                <mat-option *ngFor="let item of scopes" [value]="item">
                  {{item.text}}
                </mat-option>
              </mat-select>
            </mydocma-form-field>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="mydocma-dialog-footer" *ngIf="!this.mediaQueryService?.isXs">
      <div style="margin-right: 10px">
        <button mat-stroked-button class="mydocma-btn"
                (click)="onCancel()">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div>
        <button mat-stroked-button class="mydocma-btn-primary"
                (click)="onSaveChanges()" [disabled]="(loading$ | async) || (saving$ | async)">
          {{'MM.general.button.ok' | translate}}
        </button>
      </div>
  </div>

  <ng-template #mobileHeader>
    <div *ngIf="this.mediaQueryService?.isXs" class="mydocma-dialog-header">

      <div class="mm-pane-header mydocma-detail-header" fxFlex="row" fxFlexAlign="center space-between" style="flex: 1 1 100%">
        <button mat-stroked-button type="button" class="mydocma-btn-primary" [disabled]="(loading$ | async) || (saving$ | async)" (click)="onSaveChanges()">
          {{'MM.general.button.ok' | translate }}
        </button>

        <div class="mm-pane-header-title"
             style="display: block">
          <div class="mm-pane-header-text">{{title$ | async}}</div>
        </div>
        <button
          style="display: block"
          mat-icon-button type="button" (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>
  </ng-template>
</div>
